export interface GoogleAnalyticsPayload {
  action: string;
  label?: string;
  category?: string;
  nonInteraction?: boolean;
  impressions?: undefined;
  forOnly?: string;
  dataLayer?: { [key: string]: any };
}

export interface ClickstreamData {
  referrer?: string;
  protocol?: string;
  hostname?: string;
  pathname?: string;
  pageName?: string;
  search?: string;
  screenSize?: { w: number; h: number };
  vars?: Record<string, unknown>;
}

export interface AnalyticsPageviewPayload {
  screen_name: string;
  page_group: string;
  sub_group: string;
  brand?: string;
  nonInteraction?: undefined;
  impressions?: undefined;
  forOnly?: string;
  clickstreamData?: ClickstreamData;
  dataLayer?: { [key: string]: any };
}

export interface ClickstreamImpressionObject {
  id: string;
  rank: {
    page: { int: number };
    x: { int: number };
    y: { int: number };
  };
  vars: any;
  requestId?: string;
  visibility?: string;
}

export interface ClickstreamPayload {
  moduleName: string;
  requestId?: string;
  impressionId?: string;
  impressions?: ClickstreamImpressionObject[];
  vars?: any;
  pageName?: string;
  nonInteraction?: undefined;
}

export interface ClickstreamExperimentPayload {
  experimentName: string;
  experimentId: string;
  treatment?: string;
  treatmentName?: string;
  treatmentId?: string;
  provider?: string;
  providerSessionId?: string;
  version?: string[] | number[];
  nonInteraction?: undefined;
  impressions?: undefined;
}

export enum AnalyticsType {
  ALL = 'all',
  GOOGLE = 'google',
  CLICKSTREAM = 'clickstream',
  CLICKSTREAM_EXPERIMENT = 'clickstreamexperiment',
}

export interface AnalyticsPageviewOptions {
  pageGroup?: string;
  subGroup?: string;
  vars?: { [key: string]: any };
  dataLayer?: { [key: string]: any };
}

export interface AnalyticsOptions {
  type: AnalyticsType;
  isPageview?: boolean;
}

export type AnalyticsPayload =
  | GoogleAnalyticsPayload
  | AnalyticsPageviewPayload
  | ClickstreamPayload
  | ClickstreamExperimentPayload;

export enum AnalyticsEvents {
  CLICKSTREAM_VIEW = 'clickStream:view',
  CLICKSTREAM_EVENT = 'clickStream:event',
  TEALIUM_VIEW = 'tealium:pageView',
  TEALIUM_EVENT = 'tealium:nonPageView',
}
export interface AnalyticsEventData {
  type: AnalyticsEvents;
  data: {
    type: string;
    payload: any;
  };
}
export type LogAnalyticsFunction = (
  options: AnalyticsOptions,
  payload: AnalyticsPayload,
) => void;

export interface AnalyticsService {
  logAnalytics(options: AnalyticsOptions, payload: AnalyticsPayload): void;
  logPageview(
    pageName: string,
    analyticsType?: AnalyticsType,
    options?: AnalyticsPageviewOptions,
  ): void;
  refirePageview(): void;
}

export type AnalyticsFactory = () => AnalyticsService;
